import React, { FC, useEffect, useState, useContext } from 'react'
import CryptoJS from 'crypto-js'
import isAuthenticated from '../../routes/isAuthenticated'
import { AbilityContext } from '../../config/Can'
import { AppAbility } from '../../config/ability'
import { Card, Container, Nav, Row, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory, useRouteMatch, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import usePrevious from '../../hooks/usePrevious'
import RootState from '../../types/RootState'
import { getAccessibilities } from '../../redux/actions/accessibility'
import { getApplicationWelcomeAlert } from '../../redux/actions/applicationWelcomeAlert'
import { getServiceTypes } from '../../redux/actions/serviceType'
import { getTargetGroups } from '../../redux/actions/targetGroup'
import { getLanguages } from '../../redux/actions/language'
import { getOvernightCare } from '../../redux/actions/overnightCare'
import { getStaffingModel } from '../../redux/actions/staffingModel'
import { getWavierCompliant } from '../../redux/actions/wavierCompliant'
import { getCities, getStates, getCounties } from '../../redux/actions/location'
import {
  getLocationApplication, addLocationApplication, updateLocationApplicationGeneralInfo, updateLocationApplicationContactInfo, updateLocationApplicationOrgInfo, updateLocationApplicationDisclosureQuestions,
  updateLocationApplicationItem, updateLocationApplicationCertification, submitLocationApplication, submitLocationCertificationItems
} from '../../redux/actions/locationApplication'
import { getEthnicity } from '../../redux/actions/ethnicity'
import { getRace } from '../../redux/actions/race'
import { getWeekDay, getDateWithoutTZOffset, getLocationUploadModalData, getUploadType, getCardType, formatPhoneNumberSaved, getCertificationItemName } from '../../utils/dataTools'
import { getDomainName } from '../../utils/envVariables'
// import Application from '../../components/LocationApplicationDashboard/LocationApplication'
import Resource from '../../components/LocationApplicationDashboard/Resource'
import ActivityLog from '../../components/ApplicantDashboard/ActivityLog'
import LocationApplicationModal from '../../components/Modals/LocationApplicationModal'
import LocationCertification from '../../components/LocationApplicationDashboard/LocationCertification'
import ProviderLocationAgreementModal from '../../components/Modals/ProviderLocationAgreementModal'
import UploadModal from '../../components/Modals/UploadModal'
import OverrideValidationWarningModal from '../../components/Modals/OverrideValidationWarningModal'
import ProgressCard from '../../components/ApplicantDashboard/ProgressCard'
import RejectionNoteModal from '../../components/Modals/RejectionNoteModal'
import SubmitModal from '../../components/Modals/SubmitModal'
import request from 'superagent'

import './index.css'
import { setSelectedOrganization } from '../../redux/actions/authentication'
import LocationApplicationType from '../../types/LocationApplicationType'
import { mainColors } from '../../assets/colors'
import UploadLocationApplicationModal from '../../components/Modals/UploadLocationApplicationModal'
// import locationApplication from '../../redux/reducers/locationApplication'
import { generateAddressOption } from '../../utils/smarty'
import LocationApplication from '../../components/LocationApplicationDashboard/LocationApplication'
import Organization from '../../types/Organization'

interface Props {
  height: number;
  width: number;
}

const initialItemState = {
  type: '',
  enteredDate: null,
  fileLocation: [],
  modalType: '',
  id: 0,
  locationApplicationId: 0,
  status: '',
  notApplicable: false,
  docusignEnvelopeId: null,
  applicationType: ''
}

interface MatchParams {
  applicationId: string;
  applicationTab: string;
}

const initialOrganizationBillingState = {
  billingAddress1: '',
  billingAddress2: '',
  city: '',
  state: '',
  zipCode: '',
  contactFirstName: '',
  contactLastName: '',
  emailAddress: '',
  taxIdNumber: '',
  qualifier: '',
  npi: '',
  medicaidId: '',
  medicareId: '',
}

const initialGeneralInfoState = {
  agencyName: '',
  //legalEntity: '',
  serviceTypes: [],
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
  contactFirstName: '',
  contactLastName: '',
  emailAddress: '',
  website: '',
  phoneNumber: '',
  extension: '',
  faxNumber: '',
  taxIdNumber: '',
  qualifier: '',
  npi: '',
  medicaidId: '',
  medicareId: '',
  providerAgencyId: '',
  billingAddress1: '',
  billingAddress2: '',
  billingCity: '',
  billingState: '',
  billingZipCode: '',
  sameAsOrgBilling: false,
  newBusiness: false,
  experienceYears: '',
  relevantExperience: '',
  targetGroups: [],
  accessibility: [],
  genderServed: '',
  languages: [],
  wavierCompliant: [],
  serviceDetails: '',
  counties: [],
  countiesNotServed: [],
  monday: false,
  mondayStart: null,
  mondayEnd: null,
  tuesday: false,
  tuesdayStart: null,
  tuesdayEnd: null,
  wednesday: false,
  wednesdayStart: null,
  wednesdayEnd: null,
  thursday: false,
  thursdayStart: null,
  thursdayEnd: null,
  friday: false,
  fridayStart: null,
  fridayEnd: null,
  saturday: false,
  saturdayStart: null,
  saturdayEnd: null,
  sunday: false,
  sundayStart: null,
  sundayEnd: null,
  holiday: '',
  residentialProviderApplicants: '',
  transportationIncluded: false,
  transportation: [],
  licensedCapacity: '',
  overnightCareId: null,
  staffingModel: null,
  handicappedAccessible: null,
  equityInclusionTraining: null,
  raceId: null,
  ethnicityId: null,
  publishRaceEthnicity: null,
}

const initialContactInfoState = {
  contractingId: null,
  contractingFirstName: '',
  contractingLastName: '',
  contractingPhoneNumber: '',
  contractingFax: '',
  contractingEmailAddress: '',
  administratorId: null,
  administratorSameAsContracting: false,
  administratorFirstName: '',
  administratorLastName: '',
  administratorPhoneNumber: '',
  administratorFax: '',
  administratorEmailAddress: '',
  billingId: null,
  billingSameAsContracting: false,
  billingFirstName: '',
  billingLastName: '',
  billingPhoneNumber: '',
  billingFax: '',
  billingEmailAddress: '',
  assessmentId: null,
  assessmentSameAsContracting: false,
  assessmentFirstName: '',
  assessmentLastName: '',
  assessmentPhoneNumber: '',
  assessmentFax: '',
  assessmentEmailAddress: '',
  qualityId: null,
  qualitySameAsContracting: false,
  qualityFirstName: '',
  qualityLastName: '',
  qualityPhoneNumber: '',
  qualityFax: '',
  qualityEmailAddress: '',
  generalId: null,
  generalSameAsContracting: false,
  generalFirstName: '',
  generalLastName: '',
  generalPhoneNumber: '',
  generalFax: '',
  generalEmailAddress: ''
}

const initialFiles = {
  // w9Id: null,
  // w9: [],
  // w9File: null,
  locationFacilityLicenseId: null,
  facilityLicense: [],
  facilityLicenseFile: null,
  doesNotHaveFacilityLicense: false,
  certificateInsuranceId: null,
  certificateInsurance: [],
  certificateInsuranceFile: null,
  debarmentAttestationLetterId: null,
  debarmentAttestationLetter: [],
  debarmentAttestationLetterFile: null,
  trainingAttestationLetterId: null,
  trainingAttestationLetter: [],
  trainingAttestationLetterFile: null,
  civilRightsComplianceAttestationLetterId: null,
  civilRightsComplianceAttestationLetter: [],
  doesNotApply: false,
  civilRightsComplianceAttestationLetterFile: null,
  residentialWorksheetId: null,
  residentialWorksheet: [],
  residentialWorksheetDoesNotApply: false,
  residentialWorksheetFile: null,
  certificationApplicationId: null,
  certificationApplication: [],
  certificationApplicationFile: null,
  backgroundCheckId: null,
  backgroundCheck: [],
  backgroundCheckFile: null,
  proofOfInsuranceId: null,
  proofOfInsurance: [],
  proofOfInsuranceFile: null,
  hcbsComplianceDocumentationId: null,
  hcbsComplianceDocumentation: [],
  hcbsComplianceDocumentationFile: null,
  leaseAgreementId: null,
  leaseAgreement: [],
  leaseAgreementFile: null,
  programStatementId: null,
  programStatement: [],
  programStatementFile: null,
  emergencyEvacuationPlanId: null,
  emergencyEvacuationPlan: [],
  emergencyEvacuationPlanFile: null,
  successionPlanningId: null,
  successionPlanning: [],
  successionPlanningFile: null,
  healthAttestationId: null,
  healthAttestation: [],
  healthAttestationFile: null,
  healthAssessmentId: null,
  healthAssessment: [],
  healthAssessmentFile: null,
  healthAssessmentNotApplicable: false,
  driversLicenseAttestationId: null,
  driversLicenseAttestation: [],
  driversLicenseAttestationFile: null,
  furnaceInspectionId: null,
  furnaceInspection: [],
  furnaceInspectionFile: null,
  fireInspectionId: null,
  fireInspection: [],
  fireInspectionFile: null,
  fireExtinguisherInvoiceId: null,
  fireExtinguisherInvoice: [],
  fireExtinguisherInvoiceFile: null,
  wellTestId: null,
  wellTest: [],
  wellTestFile: null,
  wellTestNotApplicable: false,
  fireDiagramId: null,
  fireDiagram: [],
  fireDiagramFile: null,
  governmentIssuedPhotoIdId: null,
  governmentIssuedPhotoId: [],
  governmentIssuedPhotoIdFile: null,
  petVaccinationsId: null,
  petVaccinations: [],
  petVaccinationsFile: null,
  petVaccinationsNotApplicable: false,
  prescriptionMedicationStoragePolicyId: null,
  prescriptionMedicationStoragePolicy: [],
  prescriptionMedicationStoragePolicyFile: null,
  medicationAdministrationPolicyId: null,
  medicationAdministrationPolicy: [],
  medicationAdministrationPolicyFile: null,
  trainingPlanId: null,
  trainingPlan: [],
  trainingPlanFile: null,
  proofOfCurrentTrainingId: null,
  proofOfCurrentTraining: [],
  proofOfCurrentTrainingFile: null,
  backgroundCheckVerificationId: [],
  backgroundCheckVerification: [],
  backgroundCheckVerificationFiles: [],
  additionalDocuments: [],
  additionalDocumentsId: null,
  additionalDocumentsDoesNotApply: false,
  additionalDocumentsFile: [],
  removeFileList: [],
  applicationType: null
}

// const getTabProgress = (locationApplication: LocationApplicationType, key: string) => {
//   const statusKey = key === 'application' ? 'status' : 'certificationStatus'
//   let icon = <FontAwesomeIcon icon={['fas', 'info-circle']} size='3x' className='application-progress-icon' color={mainColors.warningBlue} />
//   const messageIntro = key === 'application' ? 'This application has' : 'These certfication items have'
//   let message = `${messageIntro} not been submitted yet.`

//   if (locationApplication[statusKey]) {
//     const status = locationApplication[statusKey]
//     switch (status) {
//       case 'APPROVED':
//         icon = <FontAwesomeIcon icon={['fas', 'check-circle']} size='3x' className='application-progress-icon' color={mainColors.successGreen} />
//         message = `${messageIntro} been approved and the provider has been notified.`
//         break
//       case 'REJECTED':
//         icon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} size='3x' className='application-progress-icon' color={mainColors.feedbackRed} />
//         message = `One or more items in ${messageIntro.toLowerCase()} been rejected and the provider has been notified.`
//         break
//       case 'SUBMITTED':
//         message = `${messageIntro} been submitted and require${key === 'application' ? 's' : ''} approvals.`
//         break
//       default:
//         break
//     }
//   }

//   return { icon, message }
// }

// const getHeight = (locationApplication: LocationApplicationType, key: string) => {
//   if (key === 'activitylog') return 26

//   const statusKey = key === 'application' ? 'status' : 'certificationStatus'
//   if (locationApplication[statusKey]) {
//     const status = locationApplication[statusKey]

//     const itemProgress = locationApplication && locationApplication.item ? locationApplication.item.reduce((acc, curr) => acc + (curr.status === 'APPROVED' ? 1 : 0), 0) : 0
//     const itemTotal = locationApplication && locationApplication.item ? locationApplication.item.length : 0

//     return status === 'REJECTED' || (status === 'APPROVED' && statusKey === 'certificationStatus') ? -24 : (!(status === 'SUBMITTED' && itemProgress === itemTotal) && (status === 'STARTED' || status === 'SUBMITTED' || status === 'CLOSED') ? 0 : -48)
//   }
//   return 0
// }

const LocationApplicationDashboard: FC<Props> = ({ height, width }: Props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const match = useRouteMatch<MatchParams>()
  const ability: AppAbility = useContext(AbilityContext)

  const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

  // Override Address Validation
  const [isMulti, setIsMulti] = useState(false)
  const [overridingValidation, setOverridingValidation] = useState(false)
  const [showOverrideValidationWarningModal, setShowOverrideValidationWarningModal] = useState(false)
  const [submitValues, setSubmitValues] = useState(null)

  // Redux data
  const {
    user, locationApplication, updateGeneralInfo, updateContactInfo, updateOrgInfo, updateApplicationItem,
    submitApplication, submitCertification, updateApplicationCertification, selectedOrganization
  } = useSelector((state: RootState) => ({
    user: state.authentication.user.data,
    locationApplication: state.locationApplication.locationApplication.data,
    selectedOrganization: state.authentication.selectedOrganization,
    addLocationApplicationResult: state.locationApplication.addLocationApplication,
    updateGeneralInfo: state.locationApplication.updateGeneralInfo,
    updateContactInfo: state.locationApplication.updateContactInfo,
    updateOrgInfo: state.locationApplication.updateOrgInfo,
    updateApplicationItem: state.locationApplication.updateApplicationItem,
    updateApplicationCertification: state.locationApplication.updateApplicationCertification,
    submitApplication: state.locationApplication.submitApplication,
    submitCertification: state.locationApplication.submitCertification,
    showAcknowledgmentModal: false,
    showProviderDetailModal: false,
  }))

  const isReadOnly = locationApplication?.status === 'DENIED' || locationApplication?.status === 'CLOSED';

  const [item, setItem] = useState(initialItemState)
  // Check if user can View this route
  useEffect(() => {
    if (user && user.role && user.role !== 'Admin') {
      history.push('/')
    }
  }, [ability]) // eslint-disable-line react-hooks/exhaustive-deps
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  // Check user data
  const prevUser: any = usePrevious(user)
  useEffect(() => {
    const { applicationTab, applicationId } = match.params
    // const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    // const userId = localStorage.getItem('userId') !== null && localStorage.getItem('userId') !== 'undefined' ? JSON.parse(localStorage.getItem('userId') || '') : ''
    // const email = JSON.parse(localStorage.getItem('p_sid') || '{}')
    const key = 'lakelandproviderportalinsertuserencryption'
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, key).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')

    dispatch(getLocationApplication(parseInt(applicationId), email.eid, token))

  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Check if user can View this route

  // Provider Application Form
  const [updatingLocationApplicationForm, setUpdatingLocationApplicationForm] = useState(false)

  // General Info
  const [generalInfoState, setGeneralInfoState] = useState(initialGeneralInfoState as any)
  const handleChangeGeneralInfoState = (values: any) => {
    setGeneralInfoState((previousState) => ({
      ...previousState,
      ...values
    }))
  }
  // Contact Info
  const [contactInfoState, setContactInfoState] = useState(initialContactInfoState as any)
  const handleChangeContactInfoState = (values: any) => {
    setContactInfoState((previousState) => ({
      ...previousState,
      ...values
    }))
  }
  // Organizational Info
  // const [organizationBillingState, setOrganizationBillingState] = useState(initialOrganizationBillingState as any)
  // const handleChangeOrganizationalInfoState = (values: any) => {
  //   setOrganizationBillingState((previousState) => ({
  //     ...previousState,
  //     ...values
  //   }))
  // }


  // Application Modal
  const [applicationModal, setApplicationModal] = useState(false)

  // Agreement Modal
  // const [agreementModal, setAgreementModal] = useState(false)
  // const [agreementError, setAgreementError] = useState(false)
  // const [submittingAgreement, setSubmittingAgreement] = useState(false)

  //not used
  // const handleSubmitProviderAgreement = () => {
  //   // const locationApplicationData: LocationApplicationType = useSelector((state: RootState) => state.locationApplication.locationApplication.data)
  //   const providerAgreementItem = locationApplicationData.item.find((i) => i.modalType === 'agreement')
  //   request
  //     .get(`${getDomainName()}/api/locationApplicationItem/${providerAgreementItem?.locationApplicationItemId}`)
  //     .set('Accept', 'application/json')
  //     .set('access-token', token)
  //     .then((response) => {
  //       const { signed } = response.body
  //       if (!signed) {
  //         setAgreementError(true)
  //       } else {
  //         const dataBody = {
  //           locationApplicationItemId: providerAgreementItem?.locationApplicationItemId
  //         }
  //         dispatch(updateLocationApplicationItem(token, locationApplicationData.locationApplicationId, dataBody))
  //         setSubmittingAgreement(true)
  //       }
  //     })
  //     .catch(() => {
  //       setAgreementError(true)
  //     })
  // }

  // const handleCloseAgreementModal = () => {
  //   setAgreementModal(false)
  //   setSubmittingAgreement(false)
  //   setAgreementError(false)
  // }

  // Upload Modal
  const [uploadModal, setUploadModal] = useState(false)
  const [uploadModalHeader, setUploadModalHeader] = useState('')
  const [uploadedFilesState, setUploadedFilesState] = useState(initialFiles as any)
  const [modalReadOnly, setModalReadOnly] = useState(false)
  const [uploadingDocument, setUploadingDocument] = useState(false)
  const handleOpenModal = (modalToOpen: string, modalHeader: string, readonly: boolean) => {
    if (modalToOpen === 'application') {
      setApplicationModal(true)
    } else if (modalToOpen === 'upload') {
      setUploadModal(true)
      setUploadModalHeader(getCertificationItemName(modalHeader))
    }
    setModalReadOnly(readonly)
  }

  const handleCloseApplication = () => {
    setApplicationModal(false)
    setTimeout(() => setUpdatingLocationApplicationForm(false))
    setIsMulti(false)
    setOverridingValidation(false)
    setShowOverrideValidationWarningModal(false)
    setSubmitValues(null)
  }

  const handleViewInstruction = (row: any) => {
    const domainName = getDomainName()
    if (row.status === 'CREATED') {
      const data = {
        locationApplicationCertificationId: row.locationApplicationCertificationId,
        modalType: row.modalType,
        file: null
      }

      const formData = new FormData()
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          formData.append(key, data[key])
        }
      })
      dispatch(updateLocationApplicationCertification(token, locationApplicationData.locationApplicationId, formData))
    }
    // Open document
    window.open(`${domainName}/pdf/locationapplication/certification/${row.certificationType}${row.certificationType.includes('Instruction') ? '.docx' : '.pdf'}`)
  }

  // Submit functionality
  const handleSubmitUploadFile = (values: any) => {
    const data = getLocationUploadModalData(uploadModalHeader, values)
    const uploadType = getUploadType(uploadModalHeader)

    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if (key === 'file') {
          data[key].forEach((fileItem) => formData.append(key, fileItem))
        } else {
          formData.append(key, data[key])
        }
      }

    })

    setUploadingDocument(true)
    if (uploadType === 'item') {
      dispatch(updateLocationApplicationItem(token, locationApplicationData.locationApplicationId, formData))
    }

    if (uploadType === 'certification') {
      dispatch(updateLocationApplicationCertification(token, locationApplicationData.locationApplicationId, formData))
    }
  }

  const handleCloseUploadModal = () => {
    setUploadModal(false)
    setTimeout(() => setUploadingDocument(false))
  }

  const handleSubmitApplication = (values: any, step: number, submitItem: boolean = false) => {
    if (locationApplicationData.locationApplicationId) {
      setUpdatingLocationApplicationForm(true)
      if (step === 0) {
        dispatch(updateLocationApplicationGeneralInfo(token, locationApplicationData.locationApplicationId, values))
      } else if ((step === 1)) {
        if (generalInfoState.overrideAddressValidation || generalInfoState.billingOverrideAddressValidation) {
          setIsMulti(generalInfoState.overrideAddressValidation && generalInfoState.billingOverrideAddressValidation)
          setSubmitValues({
            token,
            locationApplicationId: locationApplicationData.locationApplicationId,
            application: {
              ...generalInfoState,
              // ...contactInfoState,
              // ...organizationalInfoState,
              ...values
            },
            submitItem
          })
          setApplicationModal(false)
          setShowOverrideValidationWarningModal(true)
        } else {
          dispatch(
            updateLocationApplicationContactInfo(
              token,
              locationApplicationData.locationApplicationId, {
              ...generalInfoState,
              // ...contactInfoState,
              // ...organizationalInfoState,
              ...values
            },
              submitItem
            )
          )
        }
      }
    }
  }
  const { applicationTab } = match.params

  // Page Tabs
  const [key, setKey] = useState('')
  useEffect(() => {
    setKey(applicationTab)
  }, [applicationTab])

  useEffect(() => {
    setKey(applicationTab)

    if (applicationTab === 'resources' || applicationTab === 'activitylog' || applicationTab === 'certification') {
      setIsFirstLoad(false)
    }
  }, [match.params]) // eslint-disable-line react-hooks/exhaustive-deps

  const locationApplicationData: LocationApplicationType = useSelector((state: RootState) => state.locationApplication.locationApplication.data)
  // const selectedOrganization: Organization = useSelector((state: RootState) => state.authentication.selectedOrganization)

  // useEffect(() => {
  //   if (locationApplicationData) {
  //     // Your existing code that uses locationApplicationData
  //   }
  // }, [locationApplicationData])

  // Check if location application exists
  useEffect(() => {

    // Load General Info data
    const generalContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type === 'General') : null
    const physicalAddress = locationApplicationData?.address ? locationApplicationData.address.find((address) => address.addressType === 'Physical') : null
    const billingAddress = locationApplicationData?.address ? locationApplicationData.address.find((address) => address.addressType === 'Billing') : null
    const operationHours = {}
    if (locationApplicationData && locationApplicationData.operationHours) {
      for (let i = 0; i < 7; i++) {
        const foundDay = locationApplicationData.operationHours.find((operationDay) => operationDay.day === i)
        const weekDay = getWeekDay(i)

        if (foundDay) {
          operationHours[`${weekDay}Id`] = foundDay.locationApplicationOperationHoursId || null
          operationHours[`${weekDay}`] = true
          if (!foundDay.startTime && !foundDay.endTime) {
            operationHours[`${weekDay}NA`] = true
            operationHours[`${weekDay}Start`] = null
            operationHours[`${weekDay}End`] = null
          } else {
            operationHours[`${weekDay}NA`] = false
            operationHours[`${weekDay}Start`] = foundDay.startTime ? getDateWithoutTZOffset(new Date(foundDay.startTime)) : null
            operationHours[`${weekDay}End`] = foundDay.endTime ? getDateWithoutTZOffset(new Date(foundDay.endTime)) : null
          }
        }
        else {
          operationHours[`${weekDay}`] = false
          operationHours[`${weekDay}Start`] = null
          operationHours[`${weekDay}End`] = null
        }
      }
    }

    setGeneralInfoState((previousState) => ({
      ...previousState,
      agencyName: locationApplicationData?.agencyName || '',
      //legalEntity: locationApplicationData?.legalEntity || '',
      serviceTypes: (locationApplicationData?.serviceTypes && (locationApplicationData.serviceTypes.map(serviceType => serviceType.serviceTypeId))) || [],
      physicalAddressId: (physicalAddress && physicalAddress.locationApplicationAddressId) || null,
      address: physicalAddress ? generateAddressOption(physicalAddress) : null,
      address1: (physicalAddress && physicalAddress.address1) || '',
      address2: (physicalAddress && physicalAddress.address2) || '',
      city: (physicalAddress && physicalAddress.city) || '',
      state: (physicalAddress && physicalAddress.state) || '',
      zipCode: (physicalAddress && physicalAddress.zipCode) || '',
      overrideAddressValidation: physicalAddress ? physicalAddress.overrideAddressValidation : null,
      contactId: (generalContact && generalContact?.locationApplicationContactId) || null,
      contactFirstName: (generalContact && generalContact?.firstName) || '',
      contactLastName: (generalContact && generalContact?.lastName) || '',
      emailAddress: (generalContact && generalContact?.emailAddress) || '',
      phoneNumber: formatPhoneNumberSaved((generalContact && generalContact?.phoneNumber) || ''),
      extension: (generalContact && generalContact?.extension) || '',
      faxNumber: (generalContact && generalContact?.faxNumber) || '',
      taxIdNumber: locationApplicationData?.taxIdNumber || '',
      qualifier: locationApplicationData?.qualifier || '',
      npi: locationApplicationData?.npi || '',
      medicaidId: locationApplicationData?.medicaidId || '',
      medicareId: locationApplicationData?.medicareId || '',
      billingName: locationApplicationData?.billingName || '',
      billingAddressId: (billingAddress && billingAddress.locationApplicationAddressId) || null,
      billingAddress: billingAddress ? generateAddressOption(billingAddress) : null,
      billingAddress1: (billingAddress && billingAddress.address1) || '',
      billingAddress2: (billingAddress && billingAddress.address2) || '',
      billingCity: (billingAddress && billingAddress.city) || '',
      billingState: (billingAddress && billingAddress.state) || '',
      billingZipCode: (billingAddress && billingAddress.zipCode) || '',
      billingOverrideAddressValidation: billingAddress ? billingAddress.overrideAddressValidation : null,
      targetGroups: (locationApplicationData?.targetGroups && locationApplicationData.targetGroups.map(targetGroup => targetGroup.targetGroupId)) || [],
      accessibility: (locationApplicationData?.accessibility && locationApplicationData.accessibility.map(accessibilityOpt => accessibilityOpt.accessibilityId)) || [],
      genderServed: locationApplicationData?.genderServed || '',
      languages: (locationApplicationData?.languages && locationApplicationData.languages.map(language => language.languageId)) || [],
      wavierCompliant: (locationApplicationData?.wavierCompliant && locationApplicationData.wavierCompliant.map(compliant => compliant.homeCommunityCompliantId)) || [],
      serviceDetails: locationApplicationData?.serviceDetails || '',
      counties: (locationApplicationData?.counties && locationApplicationData.counties.reduce((acc, county) => (!county.serviced ? acc : [...acc, county.countyId]), [])) || [],
      ...operationHours,
      residentialProviderApplicants: locationApplicationData?.residentialProviderApplicants || '',
      licensedCapacity: locationApplicationData?.overnightCareId || '',
      staffingModelId: locationApplicationData?.staffingModelId || '',
      handicappedAccessible: locationApplicationData?.handicappedAccessible || false,
      equityInclusionTraining: locationApplicationData?.equityInclusionTraining || false,
      sameAsOrgBilling: locationApplicationData?.sameAsOrgBilling || false,
      raceId: locationApplicationData?.raceId,
      ethnicityId: locationApplicationData?.ethnicityId,
      publishRaceEthnicity: locationApplicationData?.publishRaceEthnicity,
    }))

    // setOrganizationBillingState((previousState) => ({
    //   ...previousState,
    //   billingAddress1: (selectedOrganization && selectedOrganization.organization_address_1 || '') || '',
    //   billingAddress2: (selectedOrganization && selectedOrganization.organization_address_2) || '',
    //   city: (selectedOrganization && selectedOrganization.organization_city) || '',
    //   state: (selectedOrganization && selectedOrganization.organization_state) || '',
    //   zipCode: (selectedOrganization && selectedOrganization.organization_zip_code) || '',
    //   contactFirstName: (selectedOrganization && selectedOrganization.organization_first_name) || '',
    //   contactLastName: (selectedOrganization && selectedOrganization.organization_last_name) || '',
    //   emailAddress: (selectedOrganization && selectedOrganization.organization_email_address) || '',
    //   taxIdNumber: selectedOrganization?.organization_tax_id_number || '',
    //   qualifier: locationApplicationData?.qualifier || '',
    //   medicaidId: selectedOrganization?.organization_medicaid_id || '',
    //   medicareId: selectedOrganization?.organization_medicare_id || '',
    // }))

    const contractingContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type.includes('Contracting')) : null
    const administratorContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type.includes('Administrator')) : null
    const billingContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type.includes('Billing')) : null
    const assessmentContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type.includes('Assessment')) : null
    const qualityContact = locationApplicationData?.contact ? locationApplicationData.contact.find((contact) => contact.type && contact.type.includes('Quality')) : null
    // const organizationBillingContact =
    // Set contact info data
    setContactInfoState({
      contractingId: (contractingContact && contractingContact.locationApplicationContactId) || null,
      contractingFirstName: (contractingContact && contractingContact.firstName) || '',
      contractingLastName: (contractingContact && contractingContact.lastName) || '',
      contractingPhoneNumber: formatPhoneNumberSaved((contractingContact && contractingContact.phoneNumber) || ''),
      contractingExtension: (contractingContact && contractingContact.extension) || '',
      contractingFax: (contractingContact && contractingContact.faxNumber) || '',
      contractingEmailAddress: (contractingContact && contractingContact.emailAddress) || '',
      administratorId: (administratorContact && administratorContact.locationApplicationContactId) || null,
      administratorSameAsContracting: false,
      administratorFirstName: (administratorContact && administratorContact.firstName) || '',
      administratorLastName: (administratorContact && administratorContact.lastName) || '',
      administratorPhoneNumber: formatPhoneNumberSaved((administratorContact && administratorContact.phoneNumber) || ''),
      administratorExtension: (administratorContact && administratorContact.extension) || '',
      administratorFax: (administratorContact && administratorContact.faxNumber) || '',
      administratorEmailAddress: (administratorContact && administratorContact.emailAddress) || '',
      billingId: (billingContact && billingContact.locationApplicationContactId) || null,
      billingSameAsContracting: false,
      billingFirstName: (billingContact && billingContact.firstName) || '',
      billingLastName: (billingContact && billingContact.lastName) || '',
      billingPhoneNumber: formatPhoneNumberSaved((billingContact && billingContact.phoneNumber) || ''),
      billingExtension: (billingContact && billingContact.extension) || '',
      billingFax: (billingContact && billingContact.faxNumber) || '',
      billingEmailAddress: (billingContact && billingContact.emailAddress) || '',
      assessmentId: (assessmentContact && assessmentContact.locationApplicationContactId) || null,
      assessmentSameAsContracting: false,
      assessmentFirstName: (assessmentContact && assessmentContact.firstName) || '',
      assessmentLastName: (assessmentContact && assessmentContact.lastName) || '',
      assessmentPhoneNumber: formatPhoneNumberSaved((assessmentContact && assessmentContact.phoneNumber) || ''),
      assessmentExtension: (assessmentContact && assessmentContact.extension) || '',
      assessmentFax: (assessmentContact && assessmentContact.faxNumber) || '',
      assessmentEmailAddress: (assessmentContact && assessmentContact.emailAddress) || '',
      qualityId: (qualityContact && qualityContact.locationApplicationContactId) || null,
      qualitySameAsContracting: false,
      qualityFirstName: (qualityContact && qualityContact.firstName) || '',
      qualityLastName: (qualityContact && qualityContact.lastName) || '',
      qualityPhoneNumber: formatPhoneNumberSaved((qualityContact && qualityContact.phoneNumber) || ''),
      qualityExtension: (qualityContact && qualityContact.extension) || '',
      qualityFax: (qualityContact && qualityContact.faxNumber) || '',
      qualityEmailAddress: (qualityContact && qualityContact.emailAddress) || ''
    })

    // Set organization info
    // setOrganizationalInfoState({
    //   culturalCompetency: locationApplication.culturalCompetency || '',
    //   serviceLimitations: locationApplication.serviceLimitations || '',
    //   qualityAssurancePlan: locationApplication.qualityAssurancePlan || '',
    //   trainingPlan: locationApplication.trainingPlan || '',
    //   payLevelsAndBenefits: locationApplication.payLevelsAndBenefits || '',
    //   unintendedEventsPolicy: locationApplication.unintendedEventsPolicy || '',
    //   businessYears: locationApplication.businessYears || ''
    // })

    // Set disclosure questions
    // setDisclosureQuestionsState({
    //   disclosureQuestion1: locationApplication.disclosureQuestion1 === null ? '' : (locationApplication.disclosureQuestion1 ? 'YES' : 'NO'),
    //   disclosureQuestion1Explanation: locationApplication.disclosureQuestion1Explanation || '',
    //   disclosureQuestion2: locationApplication.disclosureQuestion2 === null ? '' : (locationApplication.disclosureQuestion2 ? 'YES' : 'NO'),
    //   disclosureQuestion2Explanation: locationApplication.disclosureQuestion2Explanation || '',
    //   disclosureQuestion3: locationApplication.disclosureQuestion3 === null ? '' : (locationApplication.disclosureQuestion3 ? 'YES' : 'NO'),
    //   disclosureQuestion3Explanation: locationApplication.disclosureQuestion3Explanation || '',
    //   disclosureQuestion4: locationApplication.disclosureQuestion4 === null ? '' : (locationApplication.disclosureQuestion4 ? 'YES' : 'NO'),
    //   disclosureQuestion4Explanation: locationApplication.disclosureQuestion4Explanation || '',
    //   disclosureQuestion5: locationApplication.disclosureQuestion5 === null ? '' : (locationApplication.disclosureQuestion5 ? 'YES' : 'NO'),
    //   disclosureQuestion5Explanation: locationApplication.disclosureQuestion5Explanation || '',
    //   disclosureQuestion6: locationApplication.disclosureQuestion6 === null ? '' : (locationApplication.disclosureQuestion6 ? 'YES' : 'NO'),
    //   disclosureQuestion6Explanation: locationApplication.disclosureQuestion6Explanation || '',
    //   disclosureQuestion7: locationApplication.disclosureQuestion7 === null ? '' : (locationApplication.disclosureQuestion7 ? 'YES' : 'NO'),
    //   disclosureQuestion7Explanation: locationApplication.disclosureQuestion7Explanation || ''
    // })

    // Application items
    // const w9Item = locationApplication.item ? locationApplication.item.find((item) => item.itemType && item.itemType.includes('Copy of W-9')) : null
    const facilityLicenseItem = locationApplicationData && locationApplicationData.item ? locationApplicationData.item.find((item) => item.itemType && item.itemType.includes('Copy of Facility Licensure')) : null
    const certificateInsuranceItem = locationApplicationData && locationApplicationData.item ? locationApplicationData.item.find((item) => item.itemType && item.itemType.includes('Copy of Certificate of Insurance')) : null
    // const debarmentAttestationLetterItem = locationApplication.item ? locationApplication.item.find((item) => item.itemType && item.itemType.includes('Debarment Attestation Letter')) : null
    // const trainingAttestationLetterItem = locationApplication.item ? locationApplication.item.find((item) => item.itemType && item.itemType.includes('Training Attestation Letter')) : null
    // const civilRightsComplianceAttestationLetterItem = locationApplication.item ? locationApplication.item.find((item) => item.itemType && item.itemType.includes('Civil Rights Compliance Attestation Letter')) : null
    const residentialWorksheetItem = locationApplicationData?.item?.find((item) => item.itemType && item.itemType.includes('Residential Worksheets')) || null
    const backgroundCheckVerificationItem = locationApplicationData?.item?.find((item) => item.itemType && item.itemType.includes('Background Check Verification')) || null
    const additionalDocumentsItem = locationApplicationData && locationApplicationData.item ? locationApplicationData.item.find((item) => item.itemType && item.itemType.includes('Additional Documents')) : null

    // Application certifications
    const certificationApplicationItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Certification Application')) : null
    const backgroundCheckItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Background Check (BID)')) : null
    const proofOfInsuranceItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Proof of Insurance')) : null
    const hcbsComplianceDocumentationItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('HCBS Compliance Documentation')) : null
    const leaseAgreementItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Lease Agreement')) : null
    const programStatementItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Program Statement')) : null
    const emergencyEvacuationPlanItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Emergency Evacuation Plan')) : null
    const successionPlanningItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Succession Planning')) : null
    const healthAttestationItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Health Attestation')) : null
    const healthAssessmentItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Health Assessment')) : null
    const driversLicenseAttestationItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Driver\'s License Attestation')) : null
    const furnaceInspectionItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Furnace Inspection')) : null
    const fireInspectionItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Inspection')) : null
    const fireExtinguisherInvoiceItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Extinguisher Invoice')) : null
    const wellTestItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Well Test')) : null
    const fireDiagramItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Diagram')) : null
    const governmentIssuedPhotoIdItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Government Issued Photo ID')) : null
    const petVaccinationsItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Pet Vaccinations')) : null
    const prescriptionMedicationStoragePolicyItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Prescription Medication Storage Policy')) : null
    const medicationAdministrationPolicyItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Medication Administration Policy')) : null
    const trainingPlanItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Training Plan')) : null
    const proofOfCurrentTrainingItem = locationApplicationData?.certification ? locationApplicationData.certification.find((item) => item.certificationType && item.certificationType.includes('Proof of Current Training')) : null

    setUploadedFilesState({
      ...uploadedFilesState,
      // // w9Id: (w9Item && w9Item.locationApplicationItemId) || null,
      // // w9File: (w9Item && w9Item.attachment) || null,
      locationFacilityLicenseId: (facilityLicenseItem && facilityLicenseItem.locationApplicationItemId) || null,
      doesNotHaveFacilityLicense: (facilityLicenseItem && facilityLicenseItem.notApplicable) || false,
      facilityLicenseFile: (facilityLicenseItem && facilityLicenseItem.attachment) || null,
      certificateInsuranceId: (certificateInsuranceItem && certificateInsuranceItem.locationApplicationItemId) || null,
      certificateInsuranceFile: (certificateInsuranceItem && certificateInsuranceItem.attachment) || null,
      // debarmentAttestationLetterId: (debarmentAttestationLetterItem && debarmentAttestationLetterItem.locationApplicationItemId) || null,
      // debarmentAttestationLetterFile: (debarmentAttestationLetterItem && debarmentAttestationLetterItem.attachment) || null,
      // trainingAttestationLetterId: (trainingAttestationLetterItem && trainingAttestationLetterItem.locationApplicationItemId) || null,
      // trainingAttestationLetterFile: (trainingAttestationLetterItem && trainingAttestationLetterItem.attachment) || null,
      // civilRightsComplianceAttestationLetterId: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.locationApplicationItemId) || null,
      // civilRightsComplianceAttestationLetterFile: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.attachment) || null,
      // doesNotApply: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.notApplicable) || false,
      residentialWorksheetId: (residentialWorksheetItem && residentialWorksheetItem.locationApplicationItemId) || null,
      residentialWorksheetDoesNotApply: (residentialWorksheetItem && residentialWorksheetItem.notApplicable) || false,
      residentialWorksheetFile: (residentialWorksheetItem && residentialWorksheetItem.attachment) || false,
      certificationApplicationId: (certificationApplicationItem && certificationApplicationItem.locationApplicationCertificationId) || null,
      certificationApplicationFile: (certificationApplicationItem && certificationApplicationItem.attachment) || null,
      backgroundCheckId: (backgroundCheckItem && backgroundCheckItem.locationApplicationCertificationId) || null,
      backgroundCheckFile: (backgroundCheckItem && backgroundCheckItem.attachment) || null,
      proofOfInsuranceId: (proofOfInsuranceItem && proofOfInsuranceItem.locationApplicationCertificationId) || null,
      proofOfInsuranceFile: (proofOfInsuranceItem && proofOfInsuranceItem.attachment) || null,
      hcbsComplianceDocumentationId: (hcbsComplianceDocumentationItem && hcbsComplianceDocumentationItem.locationApplicationCertificationId) || null,
      hcbsComplianceDocumentationFile: (hcbsComplianceDocumentationItem && hcbsComplianceDocumentationItem.attachment) || null,
      leaseAgreementId: (leaseAgreementItem && leaseAgreementItem.locationApplicationCertificationId) || null,
      leaseAgreementFile: (leaseAgreementItem && leaseAgreementItem.attachment) || null,
      programStatementId: (programStatementItem && programStatementItem.locationApplicationCertificationId) || null,
      programStatementFile: (programStatementItem && programStatementItem.attachment) || null,
      emergencyEvacuationPlanId: (emergencyEvacuationPlanItem && emergencyEvacuationPlanItem.locationApplicationCertificationId) || null,
      emergencyEvacuationPlanFile: (emergencyEvacuationPlanItem && emergencyEvacuationPlanItem.attachment) || null,
      successionPlanningId: (successionPlanningItem && successionPlanningItem.locationApplicationCertificationId) || null,
      successionPlanningFile: (successionPlanningItem && successionPlanningItem.attachment) || null,
      healthAttestationId: (healthAttestationItem && healthAttestationItem.locationApplicationCertificationId) || null,
      healthAttestationFile: (healthAttestationItem && healthAttestationItem.attachment) || null,
      healthAssessmentId: (healthAssessmentItem && healthAssessmentItem.locationApplicationCertificationId) || null,
      healthAssessmentNotApplicable: (healthAssessmentItem && healthAssessmentItem.notApplicable) || false,
      healthAssessmentFile: (healthAssessmentItem && healthAssessmentItem.attachment) || false,
      driversLicenseAttestationId: (driversLicenseAttestationItem && driversLicenseAttestationItem.locationApplicationCertificationId) || null,
      driversLicenseAttestationFile: (driversLicenseAttestationItem && driversLicenseAttestationItem.attachment) || null,
      furnaceInspectionId: (furnaceInspectionItem && furnaceInspectionItem.locationApplicationCertificationId) || null,
      furnaceInspectionFile: (furnaceInspectionItem && furnaceInspectionItem.attachment) || null,
      fireInspectionId: (fireInspectionItem && fireInspectionItem.locationApplicationCertificationId) || null,
      fireInspectionFile: (fireInspectionItem && fireInspectionItem.attachment) || null,
      fireExtinguisherInvoiceId: (fireExtinguisherInvoiceItem && fireExtinguisherInvoiceItem.locationApplicationCertificationId) || null,
      fireExtinguisherInvoiceFile: (fireExtinguisherInvoiceItem && fireExtinguisherInvoiceItem.attachment) || null,
      wellTestId: (wellTestItem && wellTestItem.locationApplicationCertificationId) || null,
      wellTestNotApplicable: (wellTestItem && wellTestItem.notApplicable) || false,
      wellTestFile: (wellTestItem && wellTestItem.attachment) || false,
      fireDiagramId: (fireDiagramItem && fireDiagramItem.locationApplicationCertificationId) || null,
      fireDiagramFile: (fireDiagramItem && fireDiagramItem.attachment) || null,
      governmentIssuedPhotoIdId: (governmentIssuedPhotoIdItem && governmentIssuedPhotoIdItem.locationApplicationCertificationId) || null,
      governmentIssuedPhotoIdFile: (governmentIssuedPhotoIdItem && governmentIssuedPhotoIdItem.attachment) || null,
      petVaccinationsId: (petVaccinationsItem && petVaccinationsItem.locationApplicationCertificationId) || null,
      petVaccinationsNotApplicable: (petVaccinationsItem && petVaccinationsItem.notApplicable) || false,
      petVaccinationsFile: (petVaccinationsItem && petVaccinationsItem.attachment) || false,
      prescriptionMedicationStoragePolicyId: (prescriptionMedicationStoragePolicyItem && prescriptionMedicationStoragePolicyItem.locationApplicationCertificationId) || null,
      prescriptionMedicationStoragePolicyFile: (prescriptionMedicationStoragePolicyItem && prescriptionMedicationStoragePolicyItem.attachment) || null,
      medicationAdministrationPolicyId: (medicationAdministrationPolicyItem && medicationAdministrationPolicyItem.locationApplicationCertificationId) || null,
      medicationAdministrationPolicyFile: (medicationAdministrationPolicyItem && medicationAdministrationPolicyItem.attachment) || null,
      trainingPlanId: (trainingPlanItem && trainingPlanItem.locationApplicationCertificationId) || null,
      trainingPlanFile: (trainingPlanItem && trainingPlanItem.attachment) || null,
      proofOfCurrentTrainingId: (proofOfCurrentTrainingItem && proofOfCurrentTrainingItem.locationApplicationCertificationId) || null,
      proofOfCurrentTrainingFile: (proofOfCurrentTrainingItem && proofOfCurrentTrainingItem.attachment) || null,
      backgroundCheckVerificationId: (backgroundCheckVerificationItem && backgroundCheckVerificationItem.locationApplicationItemId) || null,
      backgroundCheckVerificationFiles: (backgroundCheckVerificationItem && backgroundCheckVerificationItem.backgroundCheck) || null,
      additionalDocumentsId: (additionalDocumentsItem && additionalDocumentsItem.locationApplicationItemId) || null,
      additionalDocumentsDoesNotApply: (additionalDocumentsItem && additionalDocumentsItem.notApplicable) || false,
      additionalDocumentsFile: (additionalDocumentsItem && additionalDocumentsItem.attachment) || false,
      applicationType: locationApplicationData ? locationApplicationData.applicationType : ''
    })
    // }

  }, [locationApplicationData]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    dispatch(getServiceTypes(token))
    dispatch(getCities(token))
    dispatch(getStates(token))
    dispatch(getCounties(token))
    dispatch(getTargetGroups(token))
    dispatch(getAccessibilities(token))
    dispatch(getLanguages(token))
    dispatch(getApplicationWelcomeAlert(token))
    dispatch(getWavierCompliant(token))
    dispatch(getOvernightCare(token))
    dispatch(getStaffingModel(token))
    dispatch(getEthnicity(token))
    dispatch(getRace(token))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps



  const handleChangeTab = (key: string) => {
    setKey(key)
    history.push(`/provider/locationapplication/${key}/${locationApplicationData.locationApplicationId}`)
  }

  // Rejection note
  const [showRejectionNote, setShowRejectionNote] = useState(false)
  const [rejectionNoteTitle, setRejectionNoteTitle] = useState('')
  const [selectedRejectionNote, setSelectedRejectionNote] = useState('')
  const handleOpenRejectionNote = (item: any) => {
    const rejectionNote = item && item.rejectionNote[0]
    setShowRejectionNote(true)
    setSelectedRejectionNote((rejectionNote && rejectionNote.note) || '')
    setRejectionNoteTitle(getCertificationItemName(item.itemType || item.certificationType))
  }

  const handleCloseRejectionNote = () => {
    setShowRejectionNote(false)
    setSelectedRejectionNote('')
  }

  // Submit functionality
  const [showSubmitModal, setShowSubmitModal] = useState(false)
  const [submittingApplication, setSubmittingApplication] = useState(false)
  const handleSubmitApplicationItems = () => {
    const data = {
      userId: user.user_id
    }
    if (key === 'certification') {
      dispatch(submitLocationCertificationItems(token, locationApplicationData.locationApplicationId, data))
    } else {
      dispatch(submitLocationApplication(token, locationApplicationData.locationApplicationId, data))
    }
    setSubmittingApplication(true)
  }

  const handleCloseSubmitModal = () => {
    setShowSubmitModal(false)
    setSubmittingApplication(false)
  }

  const progress = locationApplicationData && key === 'certification' ? (
    locationApplicationData && locationApplicationData.certificationProgress && locationApplicationData.certificationTotal ? (locationApplicationData.certificationProgress * 100) / locationApplicationData.certificationTotal : 0
  ) : (
    locationApplicationData && locationApplicationData.itemProgress && locationApplicationData.itemTotal ? (locationApplicationData.itemProgress * 100) / locationApplicationData.itemTotal : 0
  )

  // Override Address Validation
  const handleCloseOverrideValidationModal = () => {
    setIsMulti(false)
    setOverridingValidation(false)
    setShowOverrideValidationWarningModal(false)
    setSubmitValues(null)
  }

  const handleSubmitOverrideValidation = () => {
    dispatch(
      updateLocationApplicationDisclosureQuestions(
        submitValues.token,
        submitValues.locationApplicationId,
        submitValues.application,
        submitValues.submitItem
      )
    )
    setOverridingValidation(true)
  }

  const progressTitle = key === 'certification' ? 'Certification Items' : 'Application Completion'
  const cardType = getCardType(progress, (key === 'certification' ? locationApplicationData && locationApplicationData.certificationStatus : locationApplicationData && locationApplicationData.status))
  const cardHeight = cardType === 'started' ? -30 : (cardType === 'in progress' ? -8 : 0)
  return (
    <Container
      style={{
        paddingTop: 20,
        backgroundColor: '#f5f5f5',
        width: width,
        height: height - 20,
        maxWidth: width,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      <Row>
        <div className='applicant-header'>
          <div className='applicant-header-txt'>
            <div className='applicant-icon'>
              <FontAwesomeIcon icon={['fas', 'file-alt']} size='3x' />
            </div>
            <div className='applicant-txt'>
              <div>
                <Link to='/profile?tab=application-list' className='all-applications-txt'>
                  Back to Applications {'>'}
                </Link>
              </div>
              <h4>Application Dashboard</h4>
            </div>
          </div>
          <ProgressCard
            cardType={cardType}
            isCertification={key === 'certification'}
            progress={progress}
            progressTitle={progressTitle}
            onSubmit={() => setShowSubmitModal(true)}
          />
        </div>
      </Row>
      <Row>
        <Tab.Container id='applicant-tab' activeKey={key} onSelect={(key: any) => handleChangeTab(key)}>
          <Card style={{ border: 'none', width, height: height - 130 + cardHeight }}>
            <Card.Header>
              <Nav variant='tabs'>
                {
                  locationApplicationData && locationApplicationData.applicationType === 'residential' && locationApplicationData['12BedCertification'] ? (
                    <Nav.Item className='applicant-nav-item'>
                      <Nav.Link eventKey='certification'><b>Certification</b></Nav.Link>
                    </Nav.Item>
                  ) : null
                }
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='application'><b>Application</b></Nav.Link>
                </Nav.Item>
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='resources'><b>Resources</b></Nav.Link>
                </Nav.Item>
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='activitylog'><b>Activity Log</b></Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
            <Card.Body className='applicant-card-body'>
              <Tab.Content>
                <Tab.Pane eventKey='certification'>
                  <LocationCertification
                    locationApplication={locationApplicationData}
                    onOpenModal={handleOpenModal}
                    onOpenRejectionNote={handleOpenRejectionNote}
                    onViewInstruction={handleViewInstruction}
                    readOnly={isReadOnly}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey='application'>
                  <LocationApplication
                    locationApplication={locationApplicationData}
                    onOpenModal={handleOpenModal}
                    readOnly={isReadOnly}
                    onOpenRejectionNote={handleOpenRejectionNote}
                  />
                  <LocationApplicationModal
                    show={applicationModal}
                    applicationType={locationApplicationData ? locationApplicationData.applicationType : ''}
                    updatingLocationApplicationForm={updatingLocationApplicationForm}
                    generalInfoState={generalInfoState}
                    updateGeneralInfo={updateGeneralInfo}
                    // updateLocationApplicationGeneralInfo={updateLocationApplicationGeneralInfo}
                    onChangeGeneralInfoState={handleChangeGeneralInfoState}
                    contactInfoState={contactInfoState}
                    updateContactInfo={updateContactInfo}
                    onChangeContactInfoState={handleChangeContactInfoState}
                    // organizationBillingState={organizationBillingState}
                    selectedOrganization={selectedOrganization}
                    // organizationalInfoState={organizationalInfoState}
                    // updateOrgInfo={updateOrgInfo}
                    // onChangeOrganizationalInfoState={handleChangeOrganizationalInfoState}
                    readonly={modalReadOnly}
                    onClose={handleCloseApplication}
                    onSubmit={handleSubmitApplication} />
                  <OverrideValidationWarningModal
                    isMulti={isMulti}
                    state={updateOrgInfo}
                    saveText='You have submitted your Provider Application Form.'
                    show={showOverrideValidationWarningModal}
                    savingInProgress={overridingValidation}
                    title='Provider Application'
                    onAction={handleSubmitOverrideValidation}
                    onClose={handleCloseOverrideValidationModal} />
                  {/* <ProviderLocationAgreementModal
                    readOnly={modalReadOnly}
                    show={agreementModal}
                    user={user}
                    item={locationApplicationData && locationApplicationData.item?.find((i) => i.modalType === 'agreement')}
                    height={height}
                    width={width}
                    updateLocationApplicationItem={updateApplicationItem}
                    error={agreementError}
                    submittingAgreement={submittingAgreement}
                    onSubmit={handleSubmitProviderAgreement}
                    onClose={handleCloseAgreementModal}
                  /> */}
                </Tab.Pane>
                <Tab.Pane eventKey='resources'>
                  <Resource resources={!locationApplicationData || (locationApplicationData && !locationApplicationData.resources) ? [] : locationApplicationData.resources} />
                </Tab.Pane>
                <Tab.Pane eventKey='activitylog'>
                  <ActivityLog
                    activities={!locationApplicationData || (locationApplicationData && !locationApplicationData.activity) ? [] : locationApplicationData.activity}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Card>
        </Tab.Container>
      </Row>
      <UploadLocationApplicationModal
        show={uploadModal}
        modalHeader={uploadModalHeader}
        readonly={modalReadOnly}
        state={{
          ...uploadedFilesState,
          modalType: uploadModalHeader
        }}
        uploadingDocument={uploadingDocument}
        updateLocationApplicationCertification={updateApplicationCertification}
        updateLocationApplicationItem={updateApplicationItem}
        onClose={handleCloseUploadModal}
        onSubmit={handleSubmitUploadFile}
      />
      <RejectionNoteModal
        modalTitle={rejectionNoteTitle}
        note={selectedRejectionNote}
        show={showRejectionNote}
        onClose={handleCloseRejectionNote}
      />
      <SubmitModal
        isCertification={key === 'certification'}
        show={showSubmitModal}
        state={key === 'certification' ? submitCertification : submitApplication}
        submittingApplication={submittingApplication}
        onSubmit={handleSubmitApplicationItems}
        onClose={handleCloseSubmitModal}
      />
    </Container>
  )
}

export default isAuthenticated(LocationApplicationDashboard)